export enum FACILITIES {
  ADULTS_ONLY = 'adultsOnly',
  DISABLE_GUEST = 'disableGuest',
  CHILDREN = 'children',
  ENTERTAINMENT = 'entertainment',
  FREE_WIFI = 'freeWifi',
  HEALTH_SAFETY = 'healthSafety',
  KITCHEN = 'kitchen',
  PARKING = 'parking',
  PETS_ALLOWED = 'petsAllowed',
  SWIMMING_POOL = 'pool',
  SEAFRONT = 'seafront',
  SPA = 'spa',

  // GENERAL
  GENERAL_EV_CHARGE = 'generalEvCharge',
  GENERAL_FITNESS = 'generalFitness',
  GENERAL_ROOFTOP_TERRACE = 'generalRooftopTerrace',

  // FAMILY
  FAMILY_CHILDREN_PLAYGROUND = 'familyChildrenPlayground',
  FAMILY_BABY_SITTING = 'familyBabySitting',
  FAMILY_CHILDREN_CLUBS = 'familyChildrenClubs',
  FAMILY_CHILDREN_MEAL = 'familyChildrenMeal',
  FAMILY_CHILDREN_POOL = 'familyChildrenPool',

  // ACTIVITY
  ACTIVITIES_HIKING = 'activitiesHiking',
  ACTIVITIES_FISHING = 'activitiesFishing',
  ACTIVITIES_CYCLING = 'activitiesCycling',
  ACTIVITIES_BOARD_GAMES = 'activitiesBoardGames',
  ACTIVITIES_HORSE_RIDING = 'activitiesHorseRiding',
  ACTIVITIES_GOLF = 'activitiesGolf',
  ACTIVITIES_BICYCLE_RENTAL = 'activitiesBicycleRental',
  ACTIVITIES_CANOEING = 'activitiesCanoeing',
  ACTIVITIES_DIVING = 'activitiesDiving',
  ACTIVITIES_WINDSURFING = 'activitiesWindsurfing',
  ACTIVITIES_WATER_PARK = 'activitiesWaterPark',
  ACTIVITIES_SNORKELLING = 'activitiesSnorkelling',
  ACTIVITIES_BOWLING = 'activitiesBowling',
  ACTIVITIES_BILLIARDS = 'activitiesBilliards',
  ACTIVITIES_SCUBA = 'activitiesScuba',
  ACTIVITIES_MASSAGE = 'activitiesMassage',
  ACTIVITIES_WATER_SPORT = 'activitiesWaterSport',
  ACTIVITIES_EVENING_ENTERTAINMENT = 'activitiesEveningEntertainment',
  ACTIVITIES_TENNIS_COURT = 'activitiesTennisCourt',
  ACTIVITIES_ARCADE_ROOM = 'activitiesArcadeRoom',
  ACTIVITIES_KAYAKING = 'activitiesKayaking',
  ACTIVITIES_ECOTOURS = 'activitiesEcotours',
  ACTIVITIES_YOGA = 'activitiesYoga',
  ACTIVITIES_NIGHTCLUB = 'activitiesNightclub',
  ACTIVITIES_DARTS = 'activitiesDarts',
  ACTIVITIES_PLAY_AREA = 'activitiesPlayArea',

  // WELLNESS
  SPA_INDOOR_POOL = 'spaIndoorPool',
  SPA_ROOFTOP_POOL = 'spaRooftopPool',
  SPA_HAMMAM = 'spaHammam',
  SPA_SAUNA = 'spaSauna',
  SPA_STEAM_ROOM = 'spaSteamRoom',
  SPA_SALT_POOL = 'spaSaltPool',
  SPA_INFINITY_POOL = 'spaInfinityPool',
  SPA_WATER_SLIDE = 'spaWaterSlide',

  // FOOD
  FOOD_SUN_TERRACE = 'foodSunTerrace',
  FOOD_PICNIC = 'foodPicnic',
  FOOD_BAR = 'foodBar',
  FOOD_POOL_BAR = 'foodPoolBar',
  FOOD_RESTAURANT = 'foodRestaurant',
  FOOD_BBQ = 'foodBbq',
  FOOD_MINIMARKET = 'foodMinimarket',
}
